import { RefObject, useEffect } from 'react';

const useOutsideClick = (
  ref: RefObject<HTMLElement> | (() => HTMLElement | null | undefined),
  callback: () => void,
) => {
  useEffect(() => {
    const handleMouseDown = (e: MouseEvent) => {
      const el = typeof ref === 'function' ? ref() : ref.current;
      if (el && !el.contains(e.target as Node)) callback();
    };
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') callback();
    };
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  });
};

export default useOutsideClick;
